import { REFS } from 'enums/external-refs'
import { ICON } from 'shared/AIcon/enums'

export const HEADER_ID = 'header-menu'

export const TOP_STICKY_CONTAINER_ID = 'top-sticky-container'

export const HEADER_HEIGHT = {
  DESKTOP: 130,
  MOBILE: 64
}

export const HEADER_ITEM_ID = {
  LIVE_FEED: 'live-feed-menu-item',
  MORE: 'more-menu-item'
}

export const HEADER_MENU_ITEM_LIVE_FEED = {
  Name: 'Live Feed',
  Link: '/live-feed/',
  Icon: ICON.LIVE_FEED,
  ChildItems: [],
  Id: HEADER_ITEM_ID.LIVE_FEED
}

const HEADER_ITEM_NAME = {
  MORE: 'More'
}

const HEADER_ITEM_NAME_LOWER_CASED = Object.entries(HEADER_ITEM_NAME).reduce(
  (acc, [k, v]) => {
    acc[k] = v.toLowerCase()

    return acc
  },
  {}
)

export const HEADER_ITEM_OPTIONS_BY_NAME = {
  [HEADER_ITEM_NAME_LOWER_CASED.MORE]: {
    Id: HEADER_ITEM_ID.MORE,
    attrs: {
      'data-ref': REFS.HEADER_ITEM_MORE
    }
  }
}
